__turbopack_context__.v({
  "Emmursion__SubTitle": "GraduationCard-module-scss-module__AGBHhq__Emmursion__SubTitle",
  "Emmursion__Title": "GraduationCard-module-scss-module__AGBHhq__Emmursion__Title",
  "GraduationCard__OpenSectionTitle": "GraduationCard-module-scss-module__AGBHhq__GraduationCard__OpenSectionTitle",
  "GraduationCard__SubTitle": "GraduationCard-module-scss-module__AGBHhq__GraduationCard__SubTitle",
  "GraduationCard__Title": "GraduationCard-module-scss-module__AGBHhq__GraduationCard__Title",
  "GraduationCard__icon": "GraduationCard-module-scss-module__AGBHhq__GraduationCard__icon",
  "root": "GraduationCard-module-scss-module__AGBHhq__root",
  "rotate-icon": "GraduationCard-module-scss-module__AGBHhq__rotate-icon",
  "svg-icon": "GraduationCard-module-scss-module__AGBHhq__svg-icon",
});
